import getHostVariables from '../getHostVariables';
import {STATE, CONTEXT} from '../../symbols';

export default function getStatePropsContext(host, interactionId) {
	const hostVariables = getHostVariables(host);
	const properties = host.getResolvedProperties(interactionId);
	const state = hostVariables[STATE] || {};
	const context = hostVariables[CONTEXT];

	return {properties, state, context};
}
